<template>
  <ul class="malib-region clearfix">
    <li
      v-if="malibConf.data.length>0"
      v-for="item in malibConf.data"
      :class="{act: item.id === malibConf.id}"
      @click="cut(item.id)"
      class="option fl">
      {{item.name}}
    </li>
  </ul>
</template>

<script>
  export default {
    name: "malib_region",
    props: ['malibConf'],
    methods: {
      cut(id) {
        this.$emit('cut', {id, type:3, paging:false});
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/malib_region.vue